import axios from "axios";

import { to } from "../../helpers/api";

export const news = {
  getNews: () => {
    return axios.get(to('news'));
  }
};
